import React from 'react'
import {css} from '@emotion/react'


export default function Clock({size, renderNumbers, date}) {
  const styles = {
    root: css`
      display: block;
      position: relative;
    `,
    face: css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border: 10px solid black;
      border-radius: 50%;
    `
  }

  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  const hourHandAngle = hours * 30 + minutes / 2 + seconds / 120
  const minuteHandAngle = hours * 360 + minutes * 6 + seconds / 10
  const secondHandAngle = minutes * 360 + seconds * 6

  const clockMarks = React.useMemo(() => {
    const marks = []
    for (let i = 1; i <= 60; i++) {
      //  minute mark
      if (!!(i % 5)) {
        marks.push((
          <Mark
            key={`mark_${i}`}
            angle={i * 6}
            length={6}
            width={1}
          />
        ))
      }

      // hour mark
      if (!(i % 5)) {
        marks.push((
          <Mark
            key={`mark_${i}`}
            angle={i * 6}
            length={10}
            number={renderNumbers ? i / 5 : null}
            width={3}/>
        ))
      }
    }

    return marks
  }, [renderNumbers])

  return (
    <time
      css={styles.root}
      style={{
        width: size,
        height: size,
      }}
      dateTime={date.toISOString()}
    >
      {/* face */}
      <div css={styles.face}>
        {clockMarks.map(clockMark => clockMark)}
      </div>

      {/* hour hand */}
      <Hand
        angle={hourHandAngle}
        length={size / 11}
        name="hour"
        oppositeLength={size / 50}
        width={size / 50}
      />

      {/* minute hand */}
      <Hand
        angle={minuteHandAngle}
        length={size / 7}
        width={size / 90}
      />

      {/* second hand */}
      <Hand
        angle={secondHandAngle}
        length={size / 6}
        width={size / 180}
        color={'red'}
      />
    </time>
  )
}

function Mark({angle, length, width, number}) {
  const styles = {
    root: css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      right: 50%;
      transform: rotate(${angle}deg);
    `
  }

  return (
    <div css={styles.root}>
      <div
        css={css`
          position: absolute;
          background-color: black;
          transform: translateX(-50%);
        `}
        style={{
          width: width,
          top: 0,
          bottom: `${100 - length / 2}%`,
        }}
      />
      {number ? (
        <div
          css={css`
            position: absolute;
            left: -40px;
            width: 80px;
            text-align: center;
          `}

          style={{
            fontSize: Math.floor(length * 3),
            fontWeight: 800,
            transform: `rotate(-${angle}deg)`,
            top: `${length / 2}%`,
          }}
        >
          {number}
        </div>
      ) : null}
    </div>
  )
}


function Hand({angle = 0, length = 100, width, color}) {
  const styles = {
    root: css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      right: 50%;
      transform: rotate(${angle}deg);
    `
  }

  const oppositeLength = length / 10
  return (
    <div css={styles.root}>
      <div
        css={css`
          position: absolute;
          background-color: ${color ? color : 'black'};
          transform: translateX(-50%);
        `}
        style={{
          width: width,
          top: `${50 - length / 2}%`,
          bottom: `${50 - oppositeLength / 2}%`,
        }}
      />
    </div>
  )
}

